var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2177 4.31663V5.54325C12.5955 5.97332 13.5994 7.22061 13.5994 8.71037V12.6597C13.5994 14.504 12.0704 15.9993 10.1854 15.9993H3.4149C1.52902 15.9993 0 14.504 0 12.6597V8.71037C0 7.22061 1.00472 5.97332 2.38173 5.54325V4.31663C2.38986 1.93175 4.36515 0 6.78753 0C9.24242 0 11.2177 1.93175 11.2177 4.31663ZM6.80386 1.39096C8.454 1.39096 9.79525 2.70264 9.79525 4.31641V5.37052H3.80434V4.30051C3.81247 2.69469 5.15371 1.39096 6.80386 1.39096ZM7.51106 11.5639C7.51106 11.9534 7.19403 12.2634 6.79572 12.2634C6.40554 12.2634 6.08852 11.9534 6.08852 11.5639V9.79906C6.08852 9.41748 6.40554 9.10744 6.79572 9.10744C7.19403 9.10744 7.51106 9.41748 7.51106 9.79906V11.5639Z",
    fill: "#31414E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/pass-icon.5a590c3f09eb0b18e720ee3b2bac0776.svg";
export { ForwardRef as ReactComponent };